<template>
  <div v-if="hasPresentPercentageData" class="period-attendance-analysis">
    <period-attendance-chart
      v-if="!!presentPercentage.data.length"
      :present-percentage="presentPercentage"
      baseHexColor="#007AFF"
    ></period-attendance-chart>
    <div class="md-layout my-5">
      <div class="md-layout-item md-size-33 md-xsmall-size-100 mb-5 md:mb-0">
        <p class="text-gray-500 font-normal">
          {{ $t("attendance_report.period_attendances.avg_percentage_title") }}
        </p>
        <p
          class="text-gray-800 font-semibold text-lg"
          v-if="!isNaN(presentPercentage.data_min + '')"
        >
          {{ `${presentPercentage.data_avg.toFixed(2)} %` }}
        </p>
      </div>
      <div class="md-layout-item md-size-33 md-xsmall-size-50">
        <p class="text-gray-500 font-normal">
          {{
            $t("attendance_report.period_attendances.minimum_percentage_title")
          }}
        </p>
        <p
          class="text-gray-800 font-semibold text-lg"
          v-if="!isNaN(presentPercentage.data_min + '')"
        >
          {{ `${Number(presentPercentage.data_min).toFixed(2)} %` }}
        </p>
        <p class="text-gray-800 font-normal">
          {{ presentPercentage.label_min }}
        </p>
      </div>
      <div class="md-layout-item md-size-33 md-xsmall-size-50">
        <p class="text-gray-500 font-normal">
          {{
            $t("attendance_report.period_attendances.maximum_percentage_title")
          }}
        </p>
        <p
          class="text-gray-800 font-semibold text-lg"
          v-if="!isNaN(presentPercentage.data_max + '')"
        >
          {{ `${Number(presentPercentage.data_max).toFixed(2)} %` }}
        </p>
        <p class="text-gray-800 font-normal">
          {{ presentPercentage.label_max }}
        </p>
      </div>
    </div>
  </div>
  <no-data-found v-else class="mx-auto"></no-data-found>
</template>

<script>
import PeriodAttendanceChart from "./PeriodAttendanceChart.vue";
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";
export default {
  components: { PeriodAttendanceChart, NoDataFound },
  props: ["presentPercentage"],
  computed: {
    hasPresentPercentageData() {
      return this.presentPercentage?.data?.length;
    }
  }
};
</script>
